import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import Header from '../../components/ui/Header';

const Login = () => {
  const navigate = useNavigate();
  const { signIn, user, loading } = useAuth();

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Redirect if already logged in
  useEffect(() => {
    if (user && !loading) {
      navigate('/dashboard');
    }
  }, [user, loading, navigate]);

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const { error: signInError } = await signIn(formData?.email, formData?.password);

      if (signInError) {
        setError(signInError?.message || 'Erro ao fazer login');
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      setError('Erro inesperado. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  const fillDemoCredentials = (email, password) => {
    setFormData({ email, password });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
      </div>);

  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex items-center justify-center px-4 py-12">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-900">
              Entrar na sua conta
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              Ou{' '}
              <Link
                to="/register"
                className="font-medium text-green-600 hover:text-green-500">

                criar uma nova conta
              </Link>
            </p>
          </div>

          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div className="space-y-4">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                  Email
                </label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={formData?.email}
                  onChange={handleChange}
                  placeholder="seu@email.com"
                  className="mt-1" />

              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  Senha
                </label>
                <Input
                  id="password"
                  name="password"
                  type="password"
                  required
                  value={formData?.password}
                  onChange={handleChange}
                  placeholder="Sua senha"
                  className="mt-1" />

              </div>
            </div>

            {error &&
            <div className="rounded-md bg-red-50 p-4">
                <div className="text-sm text-red-700">{error}</div>
              </div>
            }

            <div className="flex items-center justify-between">
              <Link
                to="/forgot-password"
                className="text-sm text-green-600 hover:text-green-500">

                Esqueceu a senha?
              </Link>
            </div>

            <Button
              type="submit"
              disabled={isLoading}
              className="w-full">

              {isLoading ? 'Entrando...' : 'Entrar'}
            </Button>
          </form>

          {/* Demo Credentials Section */}
          <div className="mt-8 p-4 bg-blue-50 rounded-lg">
            <h3 className="text-sm font-medium text-blue-900 mb-3">
              Credenciais de Demonstração:
            </h3>
            <div className="space-y-2 text-xs">
              <div className="flex items-center justify-between">
                <span className="text-blue-700">Admin: admin@maisjogo.com / senha123

                </span>
                <button
                  type="button"
                  onClick={() => fillDemoCredentials('admin@pelada.com', 'senha123')}
                  className="text-blue-600 hover:text-blue-800 underline">

                  Usar
                </button>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-blue-700">Usuário: jogador@maisjogo.com / senha123

                </span>
                <button
                  type="button"
                  onClick={() => fillDemoCredentials('jogador@pelada.com', 'senha123')}
                  className="text-blue-600 hover:text-blue-800 underline">

                  Usar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>);

};

export default Login;